import { Component } from '@opten/compiler/metadata/component';
import { addClass } from '@opten/dom/add-class';

const stringPlayer = 'Player';

// todo: @opten/typescript?
class IFramePlayer {
    private _buttonElement: HTMLElement;
    private _iFrameElement: HTMLIFrameElement;

    private _boundClick = this._handleClick.bind(this);

    constructor(private element: HTMLElement) {
        this._buttonElement = element.getElementsByClassName(
            'js-player-start'
        )[0] as HTMLElement;

        this._iFrameElement = element.getElementsByTagName('iframe')[0];

        this._init();
    }

    private _init() {
        // init
        if (!(stringPlayer in this.element)) {
            // prevent adding event handlers twice
            if (this._buttonElement && this._iFrameElement) {
                this._buttonElement.addEventListener('click', this._boundClick);
            }
        }

        this.element[stringPlayer] = this;
    }

    private _handleClick() {
        this.play();
        this._buttonElement.removeEventListener('click', this._boundClick);
    }

    play() {
        // remove autoplay for all browsers, due to customer wish of 11.01.2019
        // added again, due to customer wish of 03.07.2019
        if (this._iFrameElement.src.indexOf('autoplay') === -1) {
            if (this._iFrameElement.src.indexOf('?') === -1) {
                this._iFrameElement.src += '?autoplay=1';
            } else {
                let src = this._iFrameElement.src.split('?');
                this._iFrameElement.src = src[0] + '?autoplay=1&' + src[1];
            }
            addClass(this.element, '--playing');
        }
        // addClass(this.element, '--playing');
    }
}

export default function player(element: HTMLElement) {
    let data = element[stringPlayer] as IFramePlayer;

    if (!data) {
        data = new IFramePlayer(element);
    }

    return data;
}

@Component({ className: 'js-player', observe: true })
export class Player {
    constructor(private element: HTMLElement) {
        player(element);
    }
}
